export function saveNewTimer(state, data) {
  state.tasksTimer[data.task.id] = data.timeSpentSeconds
}